import { render } from "./ShipmentInfoSection.vue?vue&type=template&id=7991e71a&scoped=true&ts=true"
import script from "./ShipmentInfoSection.vue?vue&type=script&lang=ts"
export * from "./ShipmentInfoSection.vue?vue&type=script&lang=ts"

import "./ShipmentInfoSection.vue?vue&type=style&index=0&id=7991e71a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7991e71a"]])

export default __exports__